import { ApolloError } from '@apollo/client';

import { useErpGroupSurveyAssignmentsQuery } from 'core/graphql';

import { useStableRefetch } from '../Groups/useStableRefetch';
import { IGroupSurveyAssignment } from './surveyModel';

const EMPTY_ASSIGNMENTS: IGroupSurveyAssignment[] = [];

interface IGroupSurveyAssignmentsHook {
  assignments: IGroupSurveyAssignment[];
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
}

/**
 * Spec 0011 — the «Опросы» tab of the group card: every survey attachment of
 * one group with its trigger lesson and responded/eligible counters.
 */
export const useGroupSurveyAssignments = (
  groupId?: string,
): IGroupSurveyAssignmentsHook => {
  const { data, loading, error, refetch } = useErpGroupSurveyAssignmentsQuery({
    variables: { groupId: groupId || '' },
    skip: !groupId,
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  // Stable identity — a fresh `() => refetch()` per render would loop any
  // consumer that lists it in a memo/effect dep (see useSurveys for the
  // react-table variant of this footgun).
  const stableRefetch = useStableRefetch(refetch);

  return {
    assignments: data?.groupSurveyAssignments ?? EMPTY_ASSIGNMENTS,
    loading,
    error,
    refetch: stableRefetch,
  };
};
